import React, { useEffect, useState } from 'react';

import AddIcon from '@mui/icons-material/Add';
import { Box, IconButton } from '@mui/material';
import { FileUpload } from 'components/FileUpload/layout';
import { useFormikContext } from 'formik';

import { IChunkModel } from '@common/models/Chunks/Chunk';
import { IMediaFile } from '@common/api/media';
import AnotatedFile from './AnnotatedFile';

type PropsType = {
	chunkModel: IChunkModel;
	disabled?: boolean;
};

const MAX_FILE_SIZE = 500;
const MAX_FILE_COUNT = 5;

function ChunkStudent({ chunkModel, disabled = false }: PropsType) {
	const { values } = useFormikContext<any>();
	const files = values[chunkModel.id]?.student_file || [];
	const [idx, setIdx] = useState(files.length);
	const [isNewFile, setIsNewFile] = useState(!files.length);
	const isShowMoreButton = idx < MAX_FILE_COUNT;
	const annotateFiles = values[chunkModel.id]?.annotate_file || [];

	// @TODO: refactor it
	useEffect(() => {
		if (files.length > 0) {
			setIsNewFile(false);
			setIdx(files.length);
		}
	}, [files]);

	const handleShowNewFile = () => {
		setIsNewFile(true);
	};

	return (
		<>
			{files.map((file: IMediaFile, idx: number) => {
				const annotateFile = annotateFiles
					.find((annotate: IMediaFile) => file.url.includes(annotate?.original_name));

				return (
					<>
						<FileUpload
							key={idx}
							name={`${chunkModel.id}.student_file.${idx}`}
							acceptFiles={['IMAGE', 'PDF', 'MICROSOFT_OFFICE', 'VIDEO', 'AUDIO']}
							formatsText={`JPG, PNG, PDF, Video or Office. File size no more than ${MAX_FILE_SIZE}MB`}
							maxSize={MAX_FILE_SIZE}
							disabled={disabled}
						/>
						{annotateFile && <AnotatedFile file={annotateFile} />}
					</>
				);
			})}

			{isNewFile && (
				<FileUpload
					name={`${chunkModel.id}.student_file.${idx}`}
					acceptFiles={['IMAGE', 'PDF', 'MICROSOFT_OFFICE', 'VIDEO', 'AUDIO']}
					formatsText={`JPG, PNG, PDF, Video or Office. File size no more than ${MAX_FILE_SIZE}MB`}
					maxSize={MAX_FILE_SIZE}
					disabled={disabled}
				/>
			)}

			{isShowMoreButton && (
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'center',
						gap: '4px',
					}}
				>
					<IconButton size="large" onClick={handleShowNewFile}>
						<AddIcon />
					</IconButton>
				</Box>
			)}
		</>
	);
}

export default ChunkStudent;
